module.exports = __webpack_public_path__ + "static/bg_hero_sede_prado-e5a4d7b352d2b11089cff37e262273c5.png";